module.exports = (__webpack_require__(0))(132);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/FrontPageView.js from dll-reference girder_lib
// module id = 13
// module chunks = 0